var token = ((document.getElementById("millermenu") || {}).dataset || {}).hash
/*
/*
	Base class for item management.
	Being used as an abstract class.
*/

const chargeDayN = new Array(7);
chargeDayN[5] = "Sunday";
chargeDayN[6] = "Monday";
chargeDayN[7] = "Tuesday";
chargeDayN[1] = "Wednesday";
chargeDayN[2] = "Thursday";
chargeDayN[3] = "Friday";
chargeDayN[4] = "Saturday";
const delivDayN = new Array(7);
delivDayN[1] = "Sunday";
delivDayN[2] = "Monday";
delivDayN[3] = "Tuesday";
delivDayN[4] = "Wednesday";
delivDayN[5] = "Thursday";
delivDayN[6] = "Friday";
delivDayN[7] = "Saturday";
class ItemManager {
	constructor() {
	}
	getLineItems() {
		throw new Error('Not implemented');
	}
}

/*
	NON-SUBSCRIBER SPECIFIC
	Handles updating the cart
*/
class CartItemManager extends ItemManager {
	constructor() {
		super();
	}
	fetch() {
		return fetch(...arguments)
			.then(res => {
				if (!res.ok) throw res;
				return res;
			});
	}
	fetchCart() {
		return this.fetch('/cart.js', {
			credentials: 'same-origin',
			cache: 'no-store'
		})
			.then(res => res.json());
	}
	getLineItems() {
		return this.fetchCart()
			.then(res => {
				return this._mapLineItems(res);
			});
	}
	_mapLineItems(cart) {
		return ((cart || {}).items || []).map(item => {
			return {
				id: item.id,
				variantId: item.variant_id,
				price: item.final_price / 100,
				quantity: item.quantity,
				image: item.image,
				title: item.title
			}
		});
	}
	updateQuantity(id, quantity) {
		const body = {
			updates: {
				[id]: quantity
			}
		}
		return this.fetch('/cart/update.js', { ...fetchConfig(), body: JSON.stringify(body) }) //can't use liquid in .js
			.then((res) => res.json())
			.then((res) => this._mapLineItems(res))

	}
}

/*
	SUBSCRIBER SPECIFIC
	Handles updating the cart.
*/
class SubscriptionItemManager extends ItemManager {
	constructor(opts, collection) {
		super();
		this.shop = opts.shop;
		this.customerId = opts.customerId;
		this.customerEmail = opts.email;
		this.subscriptionId = opts.subscriptionId;
		this.customer_token = opts.customer_token
		this.customer_external_token = opts.customer_external_token;
		this.maxAge = opts.maxAge || 60 * 1000;
		this.discounted_price = 6.95;
		this.subscriptionCache = { data: null, age: null };
		this.subscription = {};
		this.side_menu_subscription = collection.querySelector("#subscription_side_menu");

		this.availableDeliveryDays = [];
		this.changeNotice = document.getElementById("changeNotice")
		this.changeNotice.querySelector(".changeText").addEventListener("click", () => {
			this.changeNotice.style = "display:none;"
			this.changeNotice.querySelector(".changeWarning").innerHTML = "This is your current setting";
			this.changeNotice.querySelector(".changeWarning").style = "display:none";
		
		})
		this.set_onclick_change()

	}
	setSubscription(subscription) {
		this.subscription = subscription;
		try{	
		document.querySelector("menu-wrapper-subscription").subscriptionItemManager.subscription  = subscription
		}
		catch(error){
		}
 
	}
	set_onclick_change() {
		this.changeNotice.querySelector(".changeSubmit").addEventListener("click", () => {
			this.changeNotice.querySelector(".changeWarning").innerHTML = "This is your current setting";
			this.changeNotice.querySelector(".changeWarning").style = "display:none";
		
			if(document.getElementById("deliveryDaySelect").value)
				this.changeSub(this.subscription)
			else{
				this.changeNotice.querySelector(".changeWarning").innerHTML = "Please select a delivery day";
				this.changeNotice.querySelector(".changeWarning").style = "display:block";
			}
				
		});

	}
	setDrawerOverLay(drawer){
		this.drawerOverlay = drawer
	}

	set_active_subscription() {

	}
	changeSub = (subscription) => {
		const weekdayN = new Array(7);
		var nextBillingDate = new Date(subscription.nextBillingDate).getDay()

		weekdayN[1] = "monday";
		weekdayN[2] = "tuesday";
		weekdayN[3] = "wednesday";
		weekdayN[4] = "thursday";
		weekdayN[5] = "friday";
		weekdayN[6] = "saturday";
		weekdayN[7] = "sunday";
		const doubleCheckOptions = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*'
			}
		}
		const subChangeOptions = {
			method: 'PUT',
			headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }
		}

		const daySelect = document.querySelector("#deliveryDaySelect").value;
		var id = this.constructor._extractGid(subscription.id)
		var x = (id || this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();

		if (daySelect === "noselect") {
			
		} else {
			if (weekdayN[nextBillingDate] !== daySelect.toLowerCase()) {
				const assignBillingDate = getNextDay(daySelect)
				this.changeLoad();
				this.fetch(`cp/api/subscription-contracts-update-billing-date?hash=${hash}&email=${this.customerEmail}&contractId=` + id + "&nextBillingDate=" + assignBillingDate + "T23:00:00Z", subChangeOptions)
					.then((res) => res.json()).then((res) => {
						this.setSubscription(res)
						this.update_delivery_date_changed(res);
					})
			} else {
				document.querySelector(".changeWarning").style.display = "block"
				
			}
		}
	}
	update_order_arriving(subscription) {
		const orderDates = this.drawerOverlay.querySelector(".order-dates");
		const skipWeek = this.drawerOverlay.querySelector(".skip-week");

		const arrivingDate = orderDates.querySelector(".arriving-date");
		const changable = orderDates.querySelector(".changeable");
		const { nextBillingDate } = subscription;
		const billingDate = new Intl.DateTimeFormat("en-US", {
			weekday: "long",
			month: "long",
			day: "numeric",
		}).format(new Date(nextBillingDate));

		orderDates.style.display = "block";
		skipWeek.style.display = "block";


		//insert the actual date
		const changableUntilDate = new Date(nextBillingDate);
		changableUntilDate.setDate(changableUntilDate.getDate()); //Charge Date

		const arriveDateActual = new Date(nextBillingDate);
		arriveDateActual.setDate(arriveDateActual.getDate() + 4);
		const arriveDateActualDay = new Intl.DateTimeFormat("en", {
			weekday: "long",
			month: "long",
			day: "numeric",
		}).format(arriveDateActual);
		arrivingDate.innerText = arriveDateActualDay;

		const changableUntilWeekday = new Intl.DateTimeFormat("en", {
			weekday: "long",
		}).format(changableUntilDate); //get weekday
		const changableUntilTime = new Intl.DateTimeFormat("en", {
			hour: "numeric",
			minute: "numeric",
		}).format(changableUntilDate); //get hour and mintue

		changable.innerHTML = `Changable until ${changableUntilWeekday} at ${changableUntilTime}`;
		const bannerOrderDates = document.querySelector(
			".subscription-banner .order-dates"
		);
		if (bannerOrderDates)
			bannerOrderDates.replaceWith(orderDates.cloneNode(true));
	}
	update_delivery_date_changed(res) {
		this.changeNotice.style = "display:none;"
		var x = document.querySelector("#changeNotice");
		x.classList.remove("skipLoading");
		this.alert_succss();
		try {
			new SubscriptionSideMenu(document.getElementById("subscription_side_menu"), res).update_side_menu()
		}
		catch (error) {
			
		}
		this.update_order_arriving(res)

	}

	changeLoad = () => {
		const changeElement = document.querySelector("#changeNotice");
		changeElement.classList.add("skipLoading");
	};


	set_delivery_available_dates(subscription) {
		var geoData = {
			geoSearchQuery: subscription.deliveryMethod.address.zip,
			shop: "inspiredgo.myshopify.com"
		}
		var geoOptions = {
			method: 'POST',
			headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;' },
			body: geoData
		};
		
		fetch('https://api-us.zapiet.com/v1.0/delivery/locations?shop=inspiredgo.myshopify.com&geoSearchQuery=' + subscription.deliveryMethod.address.zip, geoOptions)
			.then(response => response.json())
			.then(async response => {
				if (response.error) {
	
				} else {
					var res = await fetch(`https://api-us.zapiet.com/v1.0/delivery/locations/${response.id}/calendar?shop=inspiredgo.myshopify.com`, geoOptions)
					var re = await res.json();
					var days = [1, 2, 3, 4, 5, 6, 7]
                    let availableDeliveryDays;
                    // If statement for if spacific days are selected from Zapeit app
                    if(re.disabled.length>0 && re.disabled[0]===true){
                      console.log("spacific dates selected")
                      const zipCode = subscription.deliveryMethod.address.city
                      //temp for blackout dates of the holidays
                      if(zipCode == "Calgary"){
                        availableDeliveryDays = [1,2,6]
                      }
                      else if(zipCode == "Vancouver"){
                        availableDeliveryDays = [1,2,3]
                        //availableDeliveryDays = [1,2,3]
                        //availableDeliveryDays = []
                      }
                      else{
                        availableDeliveryDays = [1,2]
                        //availableDeliveryDays = []
                        //availableDeliveryDays = days.filter(x => !re.disabled.includes(x));
                      }

                    }
                    else{
                      availableDeliveryDays = days.filter(x => !re.disabled.includes(x));
                    }
					//let availableDeliveryDays = days.filter(x => !re.disabled.includes(x));
					if (this.availableDeliveryDays.length <= 0) {
						this.availableDeliveryDays = availableDeliveryDays
						const daySelect = document.querySelector("#deliveryDaySelect")
						const date = new Date(subscription.nextBillingDate)
						date.setDate(date.getDate() + 4)
						daySelect.innerHTML = "";
						availableDeliveryDays.forEach((deliveryDay) => {
							if (date.getDay() + 1 == deliveryDay) {
								daySelect.innerHTML += `<option value="${chargeDayN[deliveryDay]}" selected>` + delivDayN[deliveryDay] + "</option>"

							} else {
								daySelect.innerHTML += "<option value=" + chargeDayN[deliveryDay] + ">" + delivDayN[deliveryDay] + "</option>"
							}
						})
					}
				}
			})
	}


	storeSubscription(subscription) { // possible better solution?
		// TODO: add check if it's a real subscription;
		const store = (subscription) => {
			if (subscription) this.subscriptionCache = { data: subscription, age: new Date() };
			return subscription;
		}
		if (subscription.then) return subscription.then(store); // await for response
		else return store(subscription);
	}
	async getSubscription(force = false, store = true) {
		if (!force && this.subscriptionCache.data && this.subscriptionCache.age && Date.now() - this.subscriptionCache.age < this.maxAge) {
			return this.subscriptionCache.data;
		}
		else {
			const subscription = await this.fetchSubscription(this.subscriptionId);
			if (store) this.storeSubscription(subscription);
			return subscription;
		};
	}
	getLineItems() {
		return this.getSubscription(...arguments)
			.then((res) => this.constructor._mapLineItems(res));
	}
	static fetch(path, ...args) {
		// https://inspiredgo.ca/apps/subscriptions/cp/api/subscription-customers/UCFkF3hNVXUF
		return fetch(new URL(path, `${location.origin}/apps/subscriptions/`), ...args).then(res => {
			if (!res.ok) throw res;
			return res;
		}); // force error if not ok
	}
	fetch(path,...args) {
		var headers=[ ...args]
		
		if(headers.length>0){
			headers = headers[0]
		}
		else{
			headers = {}
		}
		if(headers.headers)
			headers['headers']['externalauthorization']=`Bearer ${this.customer_external_token}`
		else
			headers['headers']={'externalauthorization':`Bearer ${this.customer_external_token}`,"Content-Type": "application/json","accept": "application/json, text/plain, */*"}
		
		headers = [headers]
		return this.constructor.fetch(path,...headers);
	}
	async fetchSubscription(id) {
		var x = (id || this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`cp/api/subscription-contracts/contract-external/${id || this.subscriptionId}?shop=${this.shop}&isExternal=true&email=${this.customerEmail}&hash=${hash}`)
			.then(res => res.json());
	}
	static _getTotalPrice(lineItems) {
		return lineItems.reduce((total, item) => {
			return total + (item.price * item.quantity);
		}, 0);
	}
	static _mapLineItems(subscriptionContract) {
		const mapped = (((subscriptionContract || {}).lines || {}).edges || []).map((edge) => {
			const node = edge.node;
			return {
				id: this._extractGid(node.id),
				variantId: this._extractGid(node.variantId),
				price: node?.currentPrice?.amount,
				discountedPrice: node?.lineDiscountedPrice?.amount ? (node?.lineDiscountedPrice?.amount / node?.quantity) : node?.currentPrice?.amount,
				quantity: node.quantity,
				title: node.title,
				image: node.variantImage.transformedSrc,
				productId: this._extractGid(node.productId)
			}
		})
		return mapped
	}
	static _extractGid(gid) {
		if (!gid) return;
		const lastSlash = gid.lastIndexOf('/');
		if (!lastSlash) return;
		return gid.slice(lastSlash + 1);
	}
	static _getVariantLineItems(lineItems, id) {
		return lineItems.filter(line => line.variantId === id);
	}
	getValidSubscriptions() {
		var x = this.customerId;
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`cp/api/subscription-customers/${this.customer_token}?shop=${this.shop}&email=${this.customerEmail}&hash=${hash}`)
			.then(res => res.json());
	}
	
	findActiveSubscription() {
		const subscriptions = [];
		return this.getValidSubscriptions()
			.then(async (res) => {
				var subscription = {}
				if (!(((res || {}).subscriptionContracts || {}).edges || []).length) return;
				for (let subscriptionId of res.subscriptionContracts.edges) {
					
					subscription = subscriptionId.node;
				
					
					if (subscription.status === 'ACTIVE')
					 {
						subscription = await this.fetchSubscription(this.constructor._extractGid(subscription.id))
						
					
						return this.storeSubscription(subscription)
					};
					subscriptions.push(subscription);
				}
				subscription = subscriptions.find(subscription => subscription.status === 'PAUSED')
				if(Object.keys(subscription).length>0){
					subscription = await this.fetchSubscription(this.constructor._extractGid(subscription.id))
				}
				return this.storeSubscription(subscription);
			});
	}
	async updateDeliveryPrice(contract_id, res) {
		var total_price = this.constructor._mapLineItems(res).reduce((total, item) => {
			return total + (item.price * item.quantity);
		}, 0);
		if (window.subscription_price) {
			if ((window.subscription_price >= 61 && total_price <= 61) || (window.subscription_price <= 61 && total_price >= 61)) {
				return await this._updateDeliveryPrice(total_price, contract_id);
			}
			else {
				return null
			}
		} else {

			return await this._updateDeliveryPrice(total_price, contract_id);
		}



	}
	_updateDeliveryPrice(total_price, contract_id) {
		var discount_price = 0;
		window.subscription_price = total_price;
		if (total_price < 61)
			discount_price = this.discounted_price;


		var x = contract_id.toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		// APPSTLE REMOVED: Update delivery price API call disabled
		// return this.constructor.fetch(`https://inspiredgo.ca/apps/appstleProxy/external/v2/subscription-contracts-update-delivery-price?contractId=${contract_id}&deliveryPrice=${discount_price}&hash=${hash}&email=${this.customerEmail}`, {
		// 	method: 'PUT'
		// }).then(res => res.json()).catch(error => { })

	}
	/*
	  These functions actually update the cart. 
	  The functions without an underscore prefix are for?
	*/
	async _addProduct(id, quantity, price) {
		this.lockQuantityInputs(id)

		var x = (this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`cp/api/v2/subscription-contracts-add-line-item?contractId=${this.subscriptionId}&quantity=${quantity}&hash=${hash}&email=${this.customerEmail}&shop=${this.shop}&variantId=gid%3A%2F%2Fshopify%2FProductVariant%2F${id}`, { method: 'PUT' })
			.then(res => res.json()).then(async (res) => {
				
				this.alert_succss()
				var res1 = await this.updateDeliveryPrice(this.subscriptionId,res)
				if(res1){
				res= res1
				}
				this.update_side_menu(res)
				this.update_menu_subscription(res);
				// if (resn) return resn;
				return res;
			})
			.finally((res) => {
				this.unlockQuantityInputs(id)
			})
	}
	update_side_menu(res){
		try{
			
		let side_menu = new SubscriptionSideMenu(document.getElementById("subscription_side_menu"), res)
			side_menu.update_side_menu()
			this.subscription = res;
			this.update_store_credit(res);
		}
		catch(error){
			console.log("error update side menu",error)
		}
	}
	get_total_price() {
		return parseFloat(SubscriptionItemManager._getTotalPrice(SubscriptionItemManager._mapLineItems(this.subscription))).toFixed(2);
	}
	get_delivery() {
		var delivery = parseFloat((this.subscription.deliveryPrice || {}).amount || 0);
		var discounts = (this.subscription.discounts || {}).edges || [];
		var found = false;
		var price = 0;
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit"))
					found = true;
			} catch (error) {

			}
		}
		if (delivery <= 0 || found) {
			delivery = "Free Shipping";
			price = 0;
		} else {
			price = delivery;

			delivery = `$${delivery}`;

		}
		return { 'text': delivery, "price": price }

	}

	async update_store_credit(subscription) {
		var balance = 0
		document.getElementById("error_message").innerHTML = ""
		document.getElementById("success_message").innerHTML = ""

		var loadingMessage = document.querySelector('.credit_available_message');
		try {
			var customer = await this.get_customer_credit()
			balance = customer.balance;
		}
		catch (error) {

		}
		// this.active_subscription = await subscription;
		var discounts = (subscription.discounts || {}).edges || [];
		var discounted_balance = 0;
		var button = document.querySelector("apply-discount-new button")
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit")) {
					if (parseFloat(discounts[i].node.value.amount.amount) >= this.get_total_price() + this.get_delivery().price)
						discounted_balance += this.get_total_price() + this.get_delivery().price;
					else{
						discounted_balance += parseFloat(discounts[i].node.value.amount.amount);
						
					}
				}
			} catch (error) {
				console.log("error",error)
			}
		}
		balance = balance - discounted_balance;
		if (balance > 0) {
			this.storeBalance = balance;
			button.style = "display:block";
			button.disabled = false;
			button.innerHTML = "Apply Store Credit to Subscription"

			loadingMessage.innerHTML = "You have $" + this.storeBalance.toFixed(2) + " in store credit available"
		} else {
			button.style = "display:none";
			button.disabled = true;

			loadingMessage.innerHTML = "No store credit available"
		}

	}
	get_customer_credit() {
		var x = (token + '').replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		// APPSTLE REMOVED: Get customer credit API call disabled
		// return fetch(`https://inspiredgo.ca/apps/appstleProxy/customers/get?hash=${hash}&email=${this.customerEmail}`,
		// 	{
		// 		method: 'POST',
		// 		headers: {
		// 			'Accept': 'application/json',
		// 			'Content-Type': 'application/json'
		// 		},
		// 		body: JSON.stringify({ "customer_email": this.customerEmail })
		// 	}
		//
		// ).then(res => res.json())
	}
	async _deleteProduct(lineId, id) {
		this.lockQuantityInputs(id);
		var x = (this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`cp/api/subscription-contracts-remove-line-item?contractId=${this.subscriptionId}&hash=${hash}&email=${this.customerEmail}&lineId=${encodeURIComponent('gid://shopify/SubscriptionLine/' + lineId)}&shop=${this.shop}`, { method: 'PUT' })
			.then(res => res.json()).then(async (res) => {
				
				this.alert_succss()
				res = await this.fetchSubscription(this.constructor._extractGid(res.id))
				var res1 = await this.updateDeliveryPrice(this.subscriptionId,res)
				if(res1){
				res= res1
				}
				this.update_side_menu(res)
				this.update_menu_subscription(res);
				return res;
			})
			.finally(() => {
				this.unlockQuantityInputs(id)
			})
	}
	alert_succss() {
		try {
			$.toast({
				title: `Success`,
				type: 'success',
				delay: 2000
			});
		}
		catch (error) {

		}
	}

	async _updateProduct(lineId, id, quantity) {
		this.lockQuantityInputs(id)
		var x = (this.subscriptionId).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetch(`cp/api/subscription-contracts-update-line-item-quantity?contractId=${this.subscriptionId}&hash=${hash}&email=${this.customerEmail}&lineId=${encodeURIComponent('gid://shopify/SubscriptionLine/' + lineId)}&quantity=${quantity}&variantId=${encodeURIComponent('gid://shopify/ProductVariant/' + id)}`, {
			method: 'PUT'
		})
			.then(res => res.json()).then(async (res) => {
				// var resn = await this.updateDeliveryPrice(this.subscriptionId, res);
				this.alert_succss()
				var res1 = await this.updateDeliveryPrice(this.subscriptionId,res)
				if(res1){
				res= res1
				}
				this.update_side_menu(res)
				// if (resn) return resn;
				this.update_menu_subscription(res);
				return res;

			})
			// Re-enable the button after the fetch has returned. This is to solve for a bug causing inaccurate quantities
			.finally((res) => {

				this.unlockQuantityInputs(id)
			})
	}
	update_menu_subscription(res){
		try{
		var menu = document.querySelector("menu-wrapper");
		menu.subscriptionItemManager.subscription = res;
		}
		catch(error){
			console.log(error)
		}
	}

	/*
			Updating product while an exsiting request is in progress
			causes the card to update with an incorrect quantity.
			Lock the inputs for that product while a request is in progress.
	*/
	lockQuantityInputs(id) {
		const inputId = `#QuantityInput-${id}`
		const menuInputId = `#MenuQuantityInput-${id}`;
		const PopupId = `#QuantityInput-popup-${id}`;
		const node = document.querySelector(inputId)?.querySelector('input');
		const menuNode = document.querySelector(menuInputId)?.querySelector('input');
		const popUpNode = document.querySelector(PopupId)?.querySelector('input');
		const buttons = document.querySelector(PopupId)?.querySelectorAll('button')
		const lockEvent = new CustomEvent('lockQuantity', { bubbles: true, detail: { variantId: id } })
		if (node) node.dispatchEvent(lockEvent)
		if (menuNode) menuNode.dispatchEvent(lockEvent);
		if (popUpNode) popUpNode.dispatchEvent(lockEvent);
		if (buttons) {
			buttons.forEach(button => {
				button.dispatchEvent(lockEvent)
			})
		}
	}

	unlockQuantityInputs(id) {
		const inputId = `#QuantityInput-${id}`
		const menuInputId = `#MenuQuantityInput-${id}`
		const PopupId = `#QuantityInput-popup-${id}`;
		const node = document.querySelector(inputId)?.querySelector('input');
		const menuNode = document.querySelector(menuInputId)?.querySelector('input');
		const popUpNode = document.querySelector(PopupId)?.querySelector('input');
		const buttons = document.querySelector(PopupId)?.querySelectorAll('button')
		const unlockEvent = new CustomEvent('unlockQuantity', { bubbles: true, detail: { variantId: id } })
		if (node) node.dispatchEvent(unlockEvent)
		if (menuNode) menuNode.dispatchEvent(unlockEvent)
		if (popUpNode) popUpNode.dispatchEvent(unlockEvent);
		if (buttons) {

			buttons.forEach(button => {
				button.dispatchEvent(unlockEvent)
			})
		}
	}


	/*
	  What does this do specifically? Why are some async and some not?
	  Write comments as to why these functions exist and what purpose they serve :)
	*/
	deleteProduct(id, variantLineItems) {
		return this.storeSubscription(this._deleteProduct(variantLineItems[0].id, id))
			.then(subscription => {
				const lineItems = this.constructor._mapLineItems(subscription);

				variantLineItems = this.constructor._getVariantLineItems(lineItems, id);
				return variantLineItems.length ? this.deleteProduct(id, variantLineItems) : subscription;
			}).catch(() => {
				document.querySelector(".drawer-btn").classList.remove("skipLoading");
				document.querySelector(".ldSpan").classList.remove("skipLoading");
			})
	}
	/*
		variantLineItems is an array of items with the same variant Ids
		if the array length > 1 there are duplicates.
		Method removes variantLineItems[0] using its UID, 
		This returns an updated subscription contract, then it uses recursion to update the quantity of the remaining line item.
		The line in the "then" function of the _deleteProduct call was parsing the line items for variants a second time but since the original variant had already been removed
		this lead to the remaining item not having its quantity updated. We only need to re-parse if the original variantLineItems array is > 2.
	*/
	updateProduct(id, quantity, price, variantLineItems = []) {
		if (variantLineItems.length > 1) {
			return this.storeSubscription(this._deleteProduct(variantLineItems[0].id, id))
				.then(subscription => {
					// TODO - this could be cleaner. re-write this recursion to be easier to read.
					if (variantLineItems.length > 2)
						variantLineItems = this.constructor._getVariantLineItems(this.constructor._mapLineItems(subscription), id)
					else variantLineItems = [variantLineItems[1]]

					return this.updateProduct(id, quantity, price, variantLineItems);
				});
		}
		else {
			if (variantLineItems.length <= 0) return;
			return this._updateProduct(variantLineItems[0].id, id, quantity, price);  //remove *quantity
		}
	}

	async updateQuantity(id, quantity, price) {
		const lineItems = await this.getLineItems(false, true);
		const variantLineItems = this.constructor._getVariantLineItems(lineItems, id);
		// add item
		if (variantLineItems.length === 0) {
			// If no items, no changes need, otherwise add the item.
			if (quantity <= 0) return;
			return this.storeSubscription(this._addProduct(id, quantity, price)); //removed *quantity
		}
		else if (variantLineItems.length >= 1) {
			// If quantity is <= 0, remove the item. Otherwise, update the quanity/press
			if (quantity <= 0) return this.deleteProduct(id, variantLineItems);
			return await this.updateProduct(id, quantity, price, variantLineItems);
		}
	}
}

/*
	Base class for displaying the collection of items
*/
class CollectionMenu {
	constructor(menuWrapper, itemManager) {
		this.menuWrapper = menuWrapper;
		this.itemManager = itemManager;
	}
	async populateProducts(gridItems, lineItems) {
		const output = [];
		// const lineItems = await this.itemManager.getLineItems();
		for (let gridItem of gridItems) {
			if (!gridItem) continue;

			const variantId = gridItem.dataset.variantid;

			if (!await this.isValidProduct(variantId)) continue;
			if (gridItem.querySelector('.quantity__input')){
			gridItem.querySelector('.quantity__input').value = lineItems.reduce((total, lineItem) => lineItem.variantId == variantId ? total + lineItem.quantity : total, 0); // get's variant's total quantity.
			}
			output.push(gridItem);
		};
		return output;
	}
	isValidProduct(variantId) {
		return true;
	}
	async appendProducts(rawProducts, productGrid, lineItems) {
		const products = await this.populateProducts(rawProducts, lineItems);

		productGrid.append(...products);
	}
	init() {
		throw new Error('Not implemented');
	}
	updateQuantity() {
		throw new Error('Not implemented');
	}
}

/*
	NON-SUBSCRIBER SPECIFIC
	menu manager
*/
class CartCollectionMenu extends CollectionMenu {
	constructor(menuWrapper, itemManager) {
		super(menuWrapper, itemManager);
	}
	async init(rawProducts, productGrid) {
		const lineItems = await this.itemManager.getLineItems();
		this.appendProducts(rawProducts, productGrid, lineItems);
		this.createBanner();
	}
	createBanner() {
		const collectionHero = (document.getElementById('collectionHero') || {}).content.cloneNode(true);
		if (!collectionHero) return;
		document.querySelector('.menu-content').appendChild(collectionHero);

	}
	updateQuantity(id, quantity) {
		return this.itemManager.updateQuantity(id, quantity);
	}
}

/*
	SUBSCRIBER SPECIFIC
	menu manager
*/
class SubscriptionCollectionMenu extends CollectionMenu {
	constructor(menuWrapper, itemManager, discount) {
		super(menuWrapper, itemManager);
		this.subscriptionCache = { data: null, age: null };
		this.changeDebounceMS = 200;
		this.discount = discount || 0;
	}
	async init(rawProducts, productGrid, subscription) {
		subscription = await this.itemManager.storeSubscription(subscription || await this.itemManager.findActiveSubscription());
		if (!subscription) throw new Error('No subscription');
		this.itemManager.subscriptionId = this.itemManager.constructor._extractGid(subscription.id);
		const lineItems = this.itemManager.constructor._mapLineItems(subscription);
		await this.appendProducts(rawProducts, productGrid, lineItems);
		/*
			Adding event listeners to lock quantity buttons while updating subscription
			TODO - replace the styles on these lock/unlock functions with togglable class names
		*/
		rawProducts.forEach(p => {
			const quantityNode = p.querySelector(".quantity")
			if (quantityNode) {
				const variantId = p.dataset.variantid
				quantityNode.id = `MenuQuantityInput-${variantId}`
				quantityNode.querySelectorAll("button").forEach(b => {
					addEventListener('lockQuantity', e => {
						if (e.detail?.variantId === variantId) {
							b.disabled = true
							b.style = "cursor: default;"
						}
					})
					addEventListener('unlockQuantity', e => {
						if (e.detail?.variantId === variantId) {
							b.disabled = false
							b.style = "cursor: initial;"
						}
					})
				})
				const inputNode = quantityNode.querySelector("input")
				inputNode.addEventListener('lockQuantity', e => {
					if (e.detail?.variantId === variantId) {
						inputNode.disabled = true
						inputNode.style = "cursor: default; background-color: #A3A3A3;"
					}
				})
				inputNode.addEventListener('unlockQuantity', e => {
					if (e.detail?.variantId === variantId) {
						inputNode.disabled = false
						inputNode.style = "cursor: initial; background-color: initial;"
					}
				})
			}

		})
		this.createBanner();
	}

	createBanner() {
		var subscriptionBanner
		try {
			subscriptionBanner = (((document.getElementById('subscriptionBanner') || {}).content || {}).querySelector('.subscription-banner') || {}).cloneNode(true);
		}
		catch (error) {
			subscriptionBanner = null;
		}

		if (!subscriptionBanner) return;
		if (!document.querySelector('.menu-content')) return;
		if (document.querySelector('.menu-content .subscription-banner')) return;
		document.querySelector('.menu-content').appendChild(subscriptionBanner);
	}
	updateQuantity(id, quantity, price) {
		price = price / 100
		return this.itemManager.updateQuantity(id, quantity, price)
			.then(res => res ? res : this.itemManager.fetchSubscription());
	}
}

/*
	Base class for displaying the menu
*/
class DrawerOverlay {
	constructor(menuWrapper, itemManager) {
		this.menuWrapper = menuWrapper;
		this.itemManager = itemManager;
		this.drawer = menuWrapper.drawer;
		this.drawerPopup = this.drawer.querySelector("#popupDrawer");
		this.itemsContainer = this.drawer.querySelector(".items-container");
		const drawerCloseBtn = this.drawer.querySelector(".drawer__close-button");
		this.drawer.addEventListener("click", (e) => {
			if (e.target !== this.drawer) return;
			this.closeDrawer();
		});
		if (drawerCloseBtn) {
			drawerCloseBtn.addEventListener("click", (e) => {
				this.closeDrawer()
			});
		}
	}

	renderItems(rawDrawerItem, lineItems, drawerItems) {
		lineItems.forEach((lineItem) => {
			const { id, image, price, title, quantity, variantId, discountedPrice } = lineItem;
			const item = rawDrawerItem.cloneNode(true);
			const productImage = item.querySelector("img");
			const productTitle = item.querySelector(".title");
			const productQuantity = item.querySelector(".quantity__input");
			const productPrice = item.querySelector(".price");
		
			/*
				Listener to lock input, +/- buttons while quanity update is happening
			*/
			const quantityInputs = item.querySelector(".quantity")
			quantityInputs.id = `QuantityInput-${variantId}`
			quantityInputs.querySelectorAll("button").forEach(b => {
				addEventListener('lockQuantity', e => {
					if (e.detail?.variantId === variantId) {
						b.disabled = true
						b.style = "cursor: default; background-color: #A3A3A3;"
					}
				})
				addEventListener('unlockQuantity', e => {
					if (e.detail?.variantId === variantId) b.disabled = false
				})
			})
			const inputNode = quantityInputs.querySelector("input")
			inputNode.addEventListener('lockQuantity', e => {
				if (e.detail?.variantId === variantId) {
					inputNode.disabled = true
					inputNode.style = "cursor: default; background-color: #A3A3A3;"
				}
			})
			inputNode.addEventListener('unlockQuantity', e => {
				if (e.detail?.variantId === variantId) inputNode.disabled = false
			})


			productImage.src = image;
			productTitle.innerText = title;
			productQuantity.value = quantity;
			productQuantity.dataset.id = variantId;
			const actualPrice = discountedPrice * quantity
			productQuantity.dataset.price = Number(price * 100).toFixed(0); // price was divied by 100 before
			productPrice.innerText = "$" + (actualPrice).toFixed(2);
			drawerItems.appendChild(item);
		});
	}
	getTotalPrice(lineItems) {
		return SubscriptionItemManager._getTotalPrice(lineItems);
	}
	getTotalProduct(lineItems) {
		return lineItems.reduce((total, item) => {
			return total + item.quantity;
		}, 0);
	}
	renderDrawerContent(lineItems, rawDrawerItem) {
		const items_subtotal_price = this.getTotalPrice(lineItems);
		const subtotalPrice = this.drawer.querySelector(".subtotal .price");
		const drawerMessage = this.drawer.querySelector(".message");
		const orderDates = this.drawer.querySelector(".order-dates");
		const skipWeek = this.drawer.querySelector(".skip-week");
		const itemQuantity = this.drawer.querySelector(".item-quantity");
		const totalItems = this.getTotalProduct(lineItems);

		this.menuWrapper.updateCartBubbles(totalItems);
		itemQuantity.innerText = totalItems;
		subtotalPrice.textContent =
			"$" + parseFloat(items_subtotal_price).toFixed(2);

		if (totalItems == 0) {
			drawerMessage.textContent = "Your Cart is Empty";
		} else {
			const awayFromFreeDelevery = (61 - items_subtotal_price);

			//check for if a customer is trying to empty their subscription
			if(items_subtotal_price < 20) {
				try{
				//pop the modal for customer to go to subscription settings to pause subscription
				const showOverlay = () => document.querySelector("#modal-contact-dark-overlay").style.display = "block";
				const showModal = () => document.querySelector("#contact-modal-container").style.display = "block";
				document.querySelector(".drawer-btn").style.zIndex = "-1";
				document.querySelector("#popupDrawer").style.display = "none";  
				showOverlay();
    			showModal();
				}
				catch(error){
					
				}
			}
			//check for if a customer is below the 40 dollar minimum order
			else if (items_subtotal_price < 40) {
				//const formatedPrice = "$" + parseFloat(awayFromFreeDelevery).toFixed(2);
				drawerMessage.innerHTML = ` <p>YOUR ORDER IS BELOW THE <span class="red-price">$40.00</span> MINIMUM ORDER AMOUNT, WE DO NOT SHIP ORDERS BELOW THIS AMOUNT.</P> <br> 
				<p> PLEASE ADD AN ADDITONAL ITEM OR PAUSE YOUR SUBSCRIPTION IN SETTINGS. </P>`;
			}
			else if(awayFromFreeDelevery > 0){
				const formatedPrice = "$" + parseFloat(awayFromFreeDelevery).toFixed(2);
				drawerMessage.innerHTML = `Only <span class="red-price">${formatedPrice}</span> Away from Free Delivery`;
			} else {
				drawerMessage.innerHTML = "";
			}
		}

		this.itemsContainer.innerHTML = "";
		this.renderItems(rawDrawerItem, lineItems, this.itemsContainer);
		if (this.itemManager.customerId) {
			this.update_order_arriving();
		} else {
			orderDates.style.display = "none";
			skipWeek.style.display = "none";
		}
		this.drawer.querySelector(".loader").style.display = "none";
	}
	openDrawer() {
		this.drawer.style.display = "block";
		this.drawerPopup.style.display = "flex";
	}
	update_order_arriving() {
		const orderDates = this.drawer.querySelector(".order-dates");
		const skipWeek = this.drawer.querySelector(".skip-week");

		const arrivingDate = orderDates.querySelector(".arriving-date");
		const changable = orderDates.querySelector(".changeable");
		const { nextBillingDate } = this.itemManager.subscriptionCache.data;
		const billingDate = new Intl.DateTimeFormat("en-US", {
			weekday: "long",
			month: "long",
			day: "numeric",
		}).format(new Date(nextBillingDate));

		orderDates.style.display = "block";
		skipWeek.style.display = "block";


		//insert the actual date
		const changableUntilDate = new Date(nextBillingDate);
		changableUntilDate.setDate(changableUntilDate.getDate()); //Charge Date

		const arriveDateActual = new Date(nextBillingDate);
		arriveDateActual.setDate(arriveDateActual.getDate() + 4);


		const arriveDateActualDay = new Intl.DateTimeFormat("en", {
			weekday: "long",
			month: "long",
			day: "numeric",
		}).format(arriveDateActual);
		arrivingDate.innerText = arriveDateActualDay;

		const changableUntilWeekday = new Intl.DateTimeFormat("en", {
			weekday: "long",
		}).format(changableUntilDate); //get weekday
		const changableUntilTime = new Intl.DateTimeFormat("en", {
			hour: "numeric",
			minute: "numeric",
		}).format(changableUntilDate); //get hour and mintue

		changable.innerHTML = `Changable until ${changableUntilWeekday} at ${changableUntilTime}`;
		const bannerOrderDates = document.querySelector(
			".subscription-banner .order-dates"
		);
		if (bannerOrderDates)
			bannerOrderDates.replaceWith(orderDates.cloneNode(true));
	}
	closeDrawer() {
		if (!this.drawerPopup) {
			this.drawerPopup = document.getElementById("popupDrawer");
		}
		this.drawerPopup.classList.add("closing-drawer");
		setTimeout(() => {
			this.drawerPopup.classList.remove("closing-drawer");
			this.drawerPopup.style.display = "none";
			if (!this.drawer) {
				this.drawer = document.querySelector(".drawer-overlay")
			}
			this.drawer.style.display = "none";
		}, 500);
	};
	updateProduct(id, quantity, price) {
		const productQuantity = this.itemsContainer.querySelector(`[data-id='${id}']`);
		const productItem = productQuantity.closest(".item");
		const productPrice = productItem.querySelector(".price");
		productPrice.innerText = "$" + parseFloat((price / 100) /* quantity */).toFixed(2);
		productQuantity.value = quantity;
	}
}

/*
	NON-SUBSCRIBER SPECIFIC
	overrides(?) the init function of the base class
	Used for fetching/rendering the menu items
*/
class CartDrawerOverlay extends DrawerOverlay {
	async init(rawDrawerItem, drawerItems) {
		const lineItems = await this.itemManager.getLineItems();
		this.renderDrawerContent(lineItems, rawDrawerItem)
	}
}

/*
	SUBSCRIBER SPECIFIC
	overrides(?) the init function of the base class
	Used for fetching/rendering the menu items
*/
class SubscriptionDrawerOverlay extends DrawerOverlay {
	async init(rawDrawerItem, drawerItems, subscription) {
		const lineItems = await this.itemManager.constructor._mapLineItems(subscription);
		this.subscription = subscription
		// this.renderItems(rawDrawerItem, lineItems, drawerItems);
		this.renderDrawerContent(lineItems, rawDrawerItem);
	}

	renderSubscriptionDrawer(subscription, rawDrawerItem) {
		const lineItems = this.itemManager.constructor._mapLineItems(subscription);
		this.subscription = subscription;
		this.renderDrawerContent(lineItems, rawDrawerItem);
	}
	renderDrawerContent(lineItems, rawDrawerItem) {
		super.renderDrawerContent(lineItems,rawDrawerItem);
		const sub_total = this.getTotalPrice(lineItems);
		var total_discount = this.get_total_discount(sub_total);

		var delivery = this.get_delivery()
		var grand_total = (sub_total - total_discount + delivery.price).toFixed(2);
		this.drawer.querySelector(".discount .price").textContent = `-$${total_discount}`;
		this.drawer.querySelector(".shipping .price").textContent = delivery.text;
		this.drawer.querySelector(".grandtotal .price").textContent = `$${grand_total > 0 ? grand_total : 0}`;
		
	}
	get_delivery() {
		var delivery = parseFloat((this.subscription.deliveryPrice || {}).amount || 0);
		var discounts = (this.subscription.discounts || {}).edges || [];
		var found = false;
		var price = 0;
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit"))
					found = true;
			} catch (error) {

			}
		}
		if (delivery <= 0 || found) {
			delivery = "Free Shipping";
			price = 0;
		} else {
			price = delivery;

			delivery = `$${delivery}`;

		}
		return { 'text': delivery, "price": price }

	}
	
	get_total_discount(sub_total) {
		var total = parseFloat(parseFloat(sub_total) + parseFloat(this.get_delivery().price)).toFixed(2);
		var discounts = (this.subscription.discounts || {}).edges || [];
		var discounted_balance = 0.0;
		var d = 0;
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit")) {
					d = parseFloat(discounts[i].node.value.amount.amount)
					if (d > total) {
						d = total;
					}
					discounted_balance += d;

				}
				else if (discounts[i].node.value.percentage) {
					discounted_balance += (discounts[i].node.value.percentage * parseFloat(sub_total)) / 100;
				}
				else if (discounts[i].node.value.amount.amount) {
					discounted_balance += parseInt(discounts[i].node.value.amount.amount);
				}
			} catch (error) {

			}
		}
		return parseFloat(discounted_balance).toFixed(2);
	}
	renderItems(rawDrawerItem, lineItems, drawerItems) {
		lineItems.forEach((lineItem) => {
			const { id, image, price, title, quantity, variantId, discountedPrice } = lineItem;
			const item = rawDrawerItem.cloneNode(true);
			const productImage = item.querySelector("img");
			const productTitle = item.querySelector(".title");
			const productQuantity = item.querySelector(".quantity__input");
			const productPrice = item.querySelector(".price");
			/*
				Listener to lock input, +/- buttons while quanity update is happening
			*/
			const quantityInputs = item.querySelector(".quantity")
			quantityInputs.id = `QuantityInput-${variantId}`
			quantityInputs.querySelectorAll("button").forEach(b => {
				addEventListener('lockQuantity', e => {
					if (e.detail?.variantId === variantId) {
						b.disabled = true
						b.style = "cursor: default; background-color: #A3A3A3;"
					}
				})
				addEventListener('unlockQuantity', e => {
					if (e.detail?.variantId === variantId) b.disabled = false
				})
			})
			const inputNode = quantityInputs.querySelector("input")
			inputNode.addEventListener('lockQuantity', e => {
				if (e.detail?.variantId === variantId) {
					inputNode.disabled = true
					inputNode.style = "cursor: default; background-color: #A3A3A3;"
				}
			})
			inputNode.addEventListener('unlockQuantity', e => {
				if (e.detail?.variantId === variantId) inputNode.disabled = false
			})


			productImage.src = image;
			productTitle.innerText = title;
			productQuantity.value = quantity;
			productQuantity.dataset.id = variantId;
			const actualPrice = price? parseFloat(price).toFixed(2) * quantity: 0
			productQuantity.dataset.price = Number(price * 100).toFixed(0); // price was divied by 100 before
			productPrice.innerText = "$" + (actualPrice).toFixed(2);
			drawerItems.appendChild(item);
		});
	}
}

// window.customer = { "id": 5085914890282, "tags": ["Appstle_Subscriber", "PF_AWARD_SOURCE: popup", "PF_AWARD_VALUE: 5DOLLARSOFF", "PF_CAMPAIGN: My First Campaign"] };
window.shop = 'inspiredgo.myshopify.com';

/*
	SUBSCRIBER SPECIFIC
	Menu Wrapper is a wrapping container wrapping all elements of the menu (including drawer)
	when the user is a subscriber.

	This is responsible for initial item load.

	Defined as a custom element: <menu-wrapper>
*/
class MenuWrapper extends HTMLElement {
	displayError(err) {
		this.collectionErrors.querySelector('.collection__error-text').innerText = err;
		this.collectionErrors.scrollIntoView(false);
	}
	onChange(event) {
		this.updateQuantity(event.target.dataset.id, parseInt(event.target.value), parseInt(event.target.dataset.price), document.activeElement.getAttribute('name'));
	}
	updateQuantity(id, quantity, price, name) {
		this.enableLoading();
		this.menu.updateQuantity(id, quantity, price)
			.then(lineItems => {
				
				this.menu.populateProducts(Array.from(this.productGrid.children), this.menu.itemManager.constructor._mapLineItems(lineItems));
				//if returns subscription object
				if (!!lineItems.customer) {
					this.drawerOverlay.renderSubscriptionDrawer(lineItems, this.templateDrawerItem)
				} else {
					this.drawerOverlay.renderDrawerContent(lineItems, this.templateDrawerItem);
				}
			})
			.catch(err => {
				console.error(err);
				this.displayError(window.collectionStrings.error);
				return this.menu.itemManager.getLineItems().then((lineItems) => this.menu.populateProducts(Array.from(this.productGrid.children), lineItems));
			})
			.finally(() => {
				this.disableLoading();
			});
	}
	updateCartBubbles(quantity) {
		const cartCounts = document.querySelectorAll(".cart-count-bubble [aria-hidden]");
		for (const cartCount of cartCounts) {
			cartCount.innerText = quantity;
		}
	}
	enableLoading() {
		this.loading = true;
		this.collection.classList.add('loading');
		document.activeElement.blur();
	}
	disableLoading() {
		this.loading = false;
		this.collection.classList.remove('loading');
	}
	connectedCallback() {
		let t = false; // prevent double running jic
		const f = () => t || ((t = true) && this.init());
		if (document.readyState !== 'loading') return f();
		else {
			window.addEventListener('DOMContentLoaded', f);
		}
	}
	init() {

		const collectionTemplate = document.getElementById(this.get_collection_template());
		if (!collectionTemplate) throw new Error('No collection template');

		const drawerTemplate = document.getElementById(this.drawerOverlayTemplate());
		if (!drawerTemplate) throw new Error('No drawer template');

		const drawerItemTemplate = document.getElementById(this.drawerItemTemplate());
		if (!drawerItemTemplate) throw new Error('No drawer item template');

		const templateCollection = collectionTemplate.content.querySelector('.igo-menu-wrapper') || collectionTemplate.content.querySelector('.collection');
		const templateDrawer = drawerTemplate.content.querySelector('.drawer-overlay');
		const templateDrawerItem = drawerItemTemplate.content.querySelector(".item");
		this.availableDeliveryDays = []
		this.collection = templateCollection.cloneNode(true);
		this.productGrid = this.collection.querySelector('#product-grid');

		// this.skipOrder = document.getElementById("")


		this.drawer = this.getDrawer(templateDrawer);
		this.drawerItems = this.drawer.querySelector('.items-container');
		this.subscription_settings_button = this.drawer.querySelector(this.get_subscription_settings_id())
		this.drawerPopup = this.drawer.querySelector("#popupDrawer");
		this.collectionErrors = this.querySelector('.collection__error');
		this.templateDrawerItem = templateDrawerItem;
		this.productPopup = window.productPopup;
		this.appstle_overlay = document.getElementById("appstle_overlay")
		this.appstle_overlay.style.display = "block";
		this.subscription_settings_button.addEventListener("click", () => {
        	// window.location.href = "https://inspiredgo.ca/apps/subscriptions#/subscriptions/list";	
          this.subscription_settings_button_on_click()
		})
		if(document.querySelector("#go-to-login-button-customer")){
			document.querySelector("#go-to-login-button-customer").addEventListener("click",()=>{
				this.subscription_settings_button_on_click()	
				hideOverlay();
      			hideModal();
			})
		}

		// Template products are the dom elements for each product card. 
		if (/*!this.collection.classList.contains('collection--empty')*/true) { // TODO: implement proper handling of empty collections.
			const templateProducts = Array.from(this.productGrid.children).filter(child => child.className === 'grid__item');
			this.productGrid.innerText = '';

			// APPSTLE REMOVED: Tag check removed, using Promise.resolve(false) as default
			let subscriptionItemManager;

			Promise.resolve(false)
				.then(async (subscription) => {
					subscriptionItemManager.set_delivery_available_dates(subscription);
					await this.initialize(subscription, subscriptionItemManager, templateProducts, templateDrawerItem)
				})
				.then(() => {
					// add change event listener
					this.debounceOnChange = debounce((event) => {
						this.onChange(event);

					}, this.menu.changeDebounceMS || 300);
					this.addEventListener('change', (event) => {
						if (event.target.className === 'quantity__input') {
							this.debounceOnChange(event);
						}
					});
					this.addEventListener('click', (event) => {
						if (event.target.name === 'plus') {
							this.add_alert(event.target.dataset.id, "Adding")


						}
						else if (event.target.name === 'minus') {
							this.add_alert(event.target.dataset.id, "Removing")


						}
					});

				})
				.catch(err => {
					console.error(err);

					this.appstle_overlay.style.display = "none"
					this.displayError(window.collectionStrings.failedToGetCart);
				});
		}
		window.addEventListener('beforeunload', (e) => {
			this.appstle_overlay.style.display = "none"
			if (this.loading) {
				e.preventDefault();
				const msg = 'Your cart changes have not finished applying.'
				e.returnValue = msg;
				return msg;
			}
		});
		this.appendChild(this.collection);
		this.appendDrawer();
	}
	appendDrawer(){
		this.appendChild(this.drawer);
	}
	getDrawer(drawer){
		return drawer.cloneNode(true)
	}

	async get_customer_token(){
		var res = await fetch(location.origin + `/apps/subscriptions?action=customer_payment_token&customer_id=${window.customer.id}`)
		res = await res.json();

		// APPSTLE REMOVED: Appstle external token disabled
		// this.customer_external_token = res.appstleExternalToken;
		this.customer_token = res.token;
	}
    
	subscription_settings_button_on_click() {
		if(document.getElementById("customer-portal-subscription")){
		document.getElementById("customer-portal-subscription").style = "display:block";
		document.getElementById("customer-portal-subscription").classList.add("max-height-0")

		setTimeout(() => {
			document.getElementById("customer-portal-subscription").classList.add("annimation-top-bottom")
			document.getElementById("collection-all").classList.remove("annimation-top-bottom")
			document.querySelector(".collection-hero").classList.remove("annimation-top-bottom")
		}, 100)
		document.getElementById("collection-all").style = "display:none";
		document.querySelector(".collection-hero").style = "display:none"
	}else{
		location.href ="/apps/subscriptions#/subscriptions/list"
	}
	}
    
	add_alert(id, text) {
		$.toast({
			title: `${text} Product`,
			type: 'success',
			delay: 2000
		});
	}
	open_modal_change_delivery() {
		let usure = document.querySelector('#changeNotice');
		usure.style.display = "flex";
		const date = new Date(this.subscriptionItemManager.subscription.nextBillingDate)
		date.setDate(date.getDate() + 4)
		document.querySelector("#deliveryDaySelect").value = chargeDayN[date.getDay()+1]
		

	}
	get_collection_template() {
		return 'collectionTemplate'
	}

	drawerOverlayTemplate() {
		return 'drawerOverlayTemplate'
	}

	drawerItemTemplate() {
		return 'drawerItemTemplate'
	}
	get_subscription_settings_id() {
		return "#subscription_settings_button"
	}

	get_subscription_item_manager(collection) {
		return new SubscriptionItemManager({ shop: window.shop, customerId: window.customer.id, email: window.customer.email,
		customer_token:this.customer_token,
		customer_external_token:this.customer_external_token
		},
			 collection);
	}
	async initialize(subscription, subscriptionItemManager, templateProducts, templateDrawerItem) {
		subscriptionItemManager.setSubscription(subscription);

		let menu;
		let drawer;
		let itemManager;
		const hasSubscription = !!subscription;
		if (hasSubscription) {
			if (subscription.status == "PAUSED" && document.getElementById("customer-portal-subscription")) {
				this.subscription_settings_button_on_click()
			}
			// ---- Begin: remove duplicate items from cart, add quantities
			itemManager = subscriptionItemManager;
			await itemManager.storeSubscription(subscription)
			itemManager.subscriptionId = itemManager.constructor._extractGid(subscription.id)
			subscription = await this.combineDuplicateItems(subscription, itemManager)
			// ---- End: 

			menu = new SubscriptionCollectionMenu(this, itemManager, window.subscriptionDiscount);
			drawer = new SubscriptionDrawerOverlay(this, itemManager);
			subscriptionItemManager.setDrawerOverLay(this.drawer)
			await menu.init(templateProducts, this.productGrid, subscription);
			await drawer.init(templateDrawerItem, this.drawerItems, subscription);
		}
		else {
			
			itemManager = new CartItemManager();
			menu = new CartCollectionMenu(this, itemManager);
			drawer = new CartDrawerOverlay(this, itemManager);

			await menu.init(templateProducts, this.productGrid);
			await drawer.init(templateDrawerItem, this.drawerItems);
		}
		this.menu = menu;
		this.drawerOverlay = drawer;
		this.itemManager = itemManager;
		if (subscription.status !== "PAUSED" && !document.getElementById("customer-portal-subscription")) {
			this.appstle_overlay.style.display = "none"
		}
	}
	/*
		Determines which items in the cart are duplicates
		Flags the duplicate for removal and adds the total quantity to the remaining item
		Calls removeDuplicates() to remove the parsed duplicate items. 
	*/
	async combineDuplicateItems(subscription, itemManager) {
		// Removing duplicate items
		const mappedItems = itemManager.constructor._mapLineItems(subscription)
		const duplicates = {}
		mappedItems.sort((a, b) => a.variantId - b.variantId)
			.forEach((item, index) => {

				if (index < mappedItems.length - 1 && item.variantId === mappedItems[index + 1].variantId) {
					// If the item is a duplicate and not already in the update array, add it to the update array. with the new quantity.
					// otherwise, just add the new quantity
					const duplicate = mappedItems[index + 1]
					if (!duplicates[item.variantId]) {
						duplicates[item.variantId] = {
							add: { ...item },
							remove: { ...duplicate }
						}
					}
					duplicates[item.variantId].add.quantity += duplicate.quantity
				}
			})

		const duplicateItems = Object.values(duplicates)
		const updatedSubscription = await this.removeDuplicates(duplicateItems, subscription, itemManager)
		// const updatedItemList = await itemManager.constructor._mapLineItems(updatedSubscription)

		return updatedSubscription
	}

	/*
		Recursively removes all duplicated items from the users cart
		Needs to be recursive due to how the Appstle subscription contract works.
	*/
	async removeDuplicates(items = [], sub, itemManager) {
		try {
			if (items?.length <= 0) return Promise.resolve(sub)
			const duplicate = items.splice(-1)
			if (!duplicate) return Promise.resolve(sub)
			const { add = {}, remove = {} } = duplicate[0]
			const updatedSubscription = await itemManager.updateProduct(add.id, add.quantity, add.price, [remove, add])
			return this.removeDuplicates(items, updatedSubscription, itemManager)
		} catch (err) {
			console.error(err)
			return Promise.resolve(sub)
		}
	}
}
customElements.define('menu-wrapper', MenuWrapper);

/*
	NON-SUBSCRIBER AND SUBSCRIBER

	Adds event listener for buttons which open the
	shopping card drawer element. 

	Defined as a custom element <drawer-open-button>
*/
class DrawerOpenButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", () => {
			const menuWrapper = document.querySelector("menu-wrapper") || document.querySelector("menu-wrapper-subscription");
			(menuWrapper.drawerOverlay || {}).openDrawer();
		});
	}
}
customElements.define("drawer-open-button", DrawerOpenButton);

/*
	Not sure why these variables are declared here.
	Seem to be use globally to handle the page loader anywhere this script is imported.
*/

var cartIconLoading = document.querySelector(".drawer-btn")
const cartBagIcon = document.querySelector("#bagIcon")
var drawerLoading = document.querySelector(".ldSpan")
const drawerInput = document.querySelector("#Quantity-template--14326752509994__product-grid")

const observer = new PerformanceObserver((list) => {
	for (const entry of list.getEntries()) {
		if (entry.initiatorType === "fetch") {
			cartIconLoading.classList.remove("skipLoading")
			drawerLoading.classList.remove("skipLoading")
		}
	}
});

observer.observe({
	entryTypes: ["resource"]
});


/*
	Turns on loading spinners when updating the cart.
*/
function subLoad() {
	drawerLoading = document.querySelector(".ldSpan")
	cartIconLoading = document.querySelector(".drawer-btn")
	cartIconLoading.classList.add("skipLoading")
	drawerLoading.classList.add("skipLoading")
}


















